import { mapGetters } from 'vuex';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import sellContent from '@/sell/components/sellcontent/sell-content.vue';

export default {
    name: 'pageSellFast',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        mvtHeader,
        mvtFooter,
        mvtShifter,
        mvtHotleadForm,
        mvtInputGeo,
        sellContent,
    },
    data() {
        return {
            geoInfo: {
                text: '',
                geo: null,
            },
        };
    },
    methods: {
        getClaimedHomeAddress(geoInfo) {
            this.$eventBus.$emit('eventbus-search-address', {
                text: geoInfo.text,
                geo: geoInfo.geo,
                getClaimedHome: true,
                getFirstListing: this.getFirstListing,
            });
        },
        getFirstListing(data) {
            if (data && data.listings && data.listings.length) {
                var listing = data.listings[0];
                this.$eventBus.$emit('dialog-center', {
                    name: 'mvtCashOffer',
                    trigger: this.$options.name,
                    opt: {
                        hotleadType: 'SellFastPageCashOffer',
                        propertyData: listing || null,
                    },
                });
            } else {
                this.$eventBus.$emit('dialog-center', { name: 'mvtGeoSearchResult', trigger: this.$options.name, opt: {} });
            }
        },
        sendCashOffer() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtCashOffer',
                trigger: this.$options.name,
                opt: {
                    hotleadType: 'SellFastPageCashOffer',
                },
            });
        },
        sendSellLead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtSellLead',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: 'Enter your current address',
                    hotleadSub: null,
                    buttonText: this.molang('dpp.hotleadForm.submit'),
                    hotleadType: 'HaveAHomeToSell',
                },
            });
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    mounted() {
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
    watch: {
        geoInfo(newVal) {
            if (newVal) {
                this.getClaimedHomeAddress(newVal);
            }
        },
    },
};
